import { render, staticRenderFns } from "./ViewAssessMarks.vue?vue&type=template&id=b87a9ffe&"
import script from "./ViewAssessMarks.vue?vue&type=script&lang=js&"
export * from "./ViewAssessMarks.vue?vue&type=script&lang=js&"
import style0 from "./ViewAssessMarks.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports